export default __webpack_public_path__ + "static/media/DouglasLopes_08.aa351fd7.jpg";